import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Edit = createSvgIcon(
  <path d="m.813 18.221-.806 5.772 5.772-.806L22.91 6.056a3.511 3.511 0 1 0-4.966-4.966L.813 18.22Zm20.6-15.436a1.262 1.262 0 0 1-.094 1.68l-1.444 1.444-1.784-1.784 1.444-1.444a1.262 1.262 0 0 1 1.877.104ZM18.283 7.5 4.721 21.063l-2.073.29.29-2.074L16.5 5.716 18.284 7.5ZM9.75 21.75H24V24H9.75v-2.25Z" />,
  'Edit'
);

export { Edit };